import React, { memo, useEffect, useState } from "react";
import "./index.scss";

import Button from "@mui/material/Button";
import AnimatedLetter from "../../AnimatedLetters/index";

import { FaDownload, FaGitAlt, FaJs, FaNode, FaReact } from "react-icons/fa";
import { ReactComponent as MongoDbSvg } from "../../../assets/image/mongodb.svg";
import { ReactComponent as NextjsSvg } from "../../../assets/image/nextJs.svg";

const About = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  return (
    <>
      <div className="about__page">
        <div className="about__containt">
          <div className="text__zone">
            <h1>
              <AnimatedLetter
                letterClass={letterClass}
                strArray={["A", "b", "o", "u", "t", " ", "M", "e"]}
                idx={15}
              />
            </h1>
            <p>
              I am a highly motivated and skilled web developer with a passion
              for creating engaging and user-friendly web applications.
            </p>
            <p>
              I possess a strong background in technologies such as HTML, CSS,
              JavaScript, React, Next.js, Bootstrap, Tailwind, Redux, Redux
              Toolkit, SASS, Node.js, Express.js, MongoDB, MySQL, and
              PostgreSQL. Additionally, I have a basic understanding of
              blockchain technology.
            </p>
            <p>
              With my attention to detail, problem-solving skills, and ability
              to work in a team, I am confident in my ability to deliver
              high-quality projects on time. I am always eager to learn new
              technologies and stay up to date with the latest industry trends.
            </p>

            <div>
              <a
                href="https://drive.google.com/file/d/1ACkQAuLQJIatCcC5DbcbtIiE7y73vMMu/view?usp=share_link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  className="download__btn"
                  endIcon={
                    <FaDownload
                      style={{ fontSize: "16px", paddingRight: "5px" }}
                    />
                  }
                >
                  Download CV
                </Button>
              </a>
            </div>
          </div>

          <div className="stage-cube-cont">
            <div className="cubespinner">
              <div className="face1">
                <FaJs color="#efd81d" />
              </div>

              <div className="face2">
                <NextjsSvg />
              </div>

              <div className="face3">
                <FaNode color="#68A063" />
              </div>

              <div className="face4">
                <FaGitAlt color="#ec4d2a" />
              </div>

              <div className="face5">
                <MongoDbSvg />
              </div>

              <div className="face6">
                <FaReact color="#5ed4f4" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(About);
